<template>
    <div class="login">
        <div class="login__form-admin">
            <div class="form-border" style="margin-top: 20%;">
                <div class="t1-subtitle" style="font-family: Open Sans; font-size: 14px;max-width: 40rem; margin-left: auto; margin-right: auto; padding-bottom: 2rem; text-align: justify;">Hola <span style="font-weight: 600" >{{userEmail}},</span> es necesario que ingreses una nueva contraseña y que la confirmes.</div>

                <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
                    <label for="password" class="form__label">Contraseña:</label>
                    <input id="password" :type="passwordVisible" v-model="password" class="form__input input-password" />
                    <img
                            @mousedown="togglePwdIcon(true)"
                            @mouseup="togglePwdIcon(false)"
                            @mouseleave="togglePwdIcon(false)"
                            :src="'/img/icons/'+showPasswordIcon"
                            class="show-password"
                    />
                    <validation-error :validation="$v.password" type="password" />
                </div>
                <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
                    <label for="repeatPassword" class="form__label">Confirmar contraseña:</label>
                    <input
                            id="repeatPassword"
                            :type="repeatPasswordVisible"
                            v-model="repeatPassword"
                            class="form__input input-password"
                    />
                    <img
                            @mousedown="toggleRepeatPwdIcon(true)"
                            @mouseup="toggleRepeatPwdIcon(false)"
                            @mouseleave="toggleRepeatPwdIcon(false)"
                            :src="'/img/icons/'+showRepeatPasswordIcon"
                            class="show-password"
                    />
                    <validation-error :validation="$v.repeatPassword" type="repetpassword" />
                </div>
                <div class="form__group">
                    <btn type="primary" @onClick="createPassword" text="CREAR NUEVA CONTRASEÑA" />
                    <p class="forgot-password" @click="goToLogin">IR A INICIAR SESIÓN</p>
                </div>
            </div>
        </div>
        <div class="login__bg-admin"></div>
        <Loader v-show="isLoading" />
        <Popup ref="resetPasswordComplete" size="xs">
            <div class="text-center">
                <h1 class="text-center title-forgot-pwd mb-3">SE HA CAMBIADO LA CONTRASEÑA</h1>
                <p
                        class="forgot-pwd-text"
                        style="font-size: 19px;"
                >La contraseña ha sido cambiada correctamente.</p>
                <img src="/img/icons/ok.svg" width="200px" height="auto" alt="icono-correcto" />
                <div class="form__group mt-5">
                    <btn type="primary" @onClick="goToLogin" text="INICIAR SESIÓN" />
                </div>
            </div>
        </Popup>
    </div>
</template>
<script>
    import Btn from "../core/Button";
    import Popup from "../core/Popup";
    import Swal from "sweetalert2";
    import { mapActions } from "vuex";
    import { required, minLength, sameAs } from "vuelidate/lib/validators";
    import { hasNumeric, hasUppercase } from "../../validations";
    import ValidationError from "./misc/ValidationError";
    import Loader from "../core/Loader";

    export default {
        name: "ResetPassword",
        components: {
            Loader,
            Btn,
            Popup,
            ValidationError
        },
        data() {
            return {
                isLoading: false,
                password: "",
                repeatPassword: "",
                passwordVisible: "password",
                repeatPasswordVisible: "password",
                token: "",
                userEmail: ""
            };
        },
        validations: {
            password: {
                required,
                minLength: minLength(8),
                hasUppercase,
                hasNumeric
            },
            repeatPassword: {
                required,
                sameAs: sameAs("password")
            }
        },
        mounted() {
            this.token = this.$route.query.token;
            this.userEmail = this.$route.query.email;
            this.userType = this.$route.query.userType;
        },
        computed: {
            showPasswordIcon() {
                let icon = "";
                if (this.passwordVisible === "password") {
                    icon = "password-hidden.svg";
                } else {
                    icon = "password-visible.svg";
                }
                return icon;
            },
            showRepeatPasswordIcon() {
                let icon = "";
                if (this.repeatPasswordVisible === "password") {
                    icon = "password-hidden.svg";
                } else {
                    icon = "password-visible.svg";
                }
                return icon;
            }
        },
        methods: {
            ...mapActions(["resetPassword"]),
            togglePwdIcon(icon){
                if(icon){
                    this.passwordVisible = 'text';
                } else {
                    this.passwordVisible = 'password';
                }
            },
            toggleRepeatPwdIcon(icon){
                if(icon){
                    this.repeatPasswordVisible = 'text';
                } else {
                    this.repeatPasswordVisible = 'password';
                }
            },
            goToLogin(){
                this.$refs.resetPasswordComplete.toggleModal();
                this.$store.commit("clearAuthentication");
                if (parseInt(this.userType) === 2) {
                    this.$router.push("/");
                } else {
                    this.$router.push("/");
                }
            },
            async createPassword(){
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                try {
                    const body = {
                        token: this.token,
                        password: this.password
                    };
                    this.isLoading = true;
                    let response = await this.resetPassword(body);
                    if (response.data.status === 200) {
                        this.$refs.resetPasswordComplete.toggleModal();
                    } else {
                        this.pushNotifyError();
                    }
                } catch (error){
                    if (error && error.response && error.response.data && error.response.data.errorDetails) {
                        this.errorMessage(error.response.data.errorDetails);
                    } else {
                        this.pushNotifyError();
                    }
                } finally {
                    this.isLoading = false;
                }
            },
            errorMessage(message) {
                Swal.fire({
                    title:
                        "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans,serif; color: #dc7134'>¡ATENCIÓN!</span>",
                    html:
                        "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans,serif; color: #828282'>" +
                       `<p>${message}</p>` +
                        "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
                        "</div>",
                    allowOutsideClick: false,
                    width: "50rem",
                    padding: "2rem",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#dc7134",
                    customClass: {
                        confirmButton: "t1-btn t1-btn--primary-block"
                    },
                });
            },
            pushNotifyError(){
                this.$notify.error({
                    message: "Ha ocurrido un error, inténtalo más tarde.",
                    position: "top right",
                    timeOut: 15000
                });
            },
        }
    };
</script>
<style lang="scss">
    $medium-grey: #828282;

    .input-password {
        display: inline;
    }

    .btn-inline {
        display: inline;
        &:not(:last-child) {
            padding-right: 1.5rem;
        }
    }

    .show-password {
        position: absolute;
        padding-top: 1.1rem;
        padding-left: 0.5rem;
        display: inline;
    }

    .title-forgot-pwd {
        text-transform: uppercase;
        color: $medium-grey;
        font-weight: 400;
        font-family: Josefin Sans;
        font-size: 2rem;
    }

    .forgot-pwd-text {
        color: $medium-grey;
        font-size: 1.2rem;
        padding: 0.5rem 0.5rem;
        text-align: center;
    }
</style>